import { fetchWithAuth } from '../utils/apiUtils';

export default class OrganizationService {
    private static setupPath = 'identity/organization/setup';
    private static orgPath = 'identity/organization';

    constructor() { }

    public static async attachPaymentMethodDuringSetup(setupToken: string, paymentMethodId: string) {
        const response = await fetch(`${process.env.REACT_APP_FIELD_API}/${this.setupPath}/payment-methods`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${setupToken}`
            },
            body: JSON.stringify({
                paymentMethodId
            })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `Failed to attach payment method during setup: ${response.status}`);
        }

        return await response.json();
    }

    public static async getOrganizationDetails() {
        const response = await fetchWithAuth(`${this.orgPath}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `Failed to fetch organization details: ${response.status}`);
        }

        return await response.json();
    }

    public static async createSetupIntent(): Promise<{
        clientSecret: string;
        paymentMethods: Array<{
            id: string;
            brand: string;
            last4: string;
            expMonth: number;
            expYear: number;
            isDefault: boolean;
        }>;
    }> {
        const response = await fetchWithAuth(`${this.orgPath}/create-setup-intent`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `Failed to create setup intent: ${response.status}`);
        }

        return await response.json();
    }

    public static async resolvePastDueSubscription(paymentMethodId: string): Promise<{ subscriptionStatus: string }> {
        const response = await fetchWithAuth(`${this.orgPath}/resolve-past-due`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ paymentMethodId })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `Failed to resolve past-due subscription: ${response.status}`);
        }

        return await response.json();
    }
}
